import { render } from "./link-preview.vue?vue&type=template&id=0e42193a"
import script from "./link-preview.js?vue&type=script&lang=js"
export * from "./link-preview.js?vue&type=script&lang=js"

import "./link-preview.vue?vue&type=style&index=0&id=0e42193a&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__